import { selector } from 'recoil';

import cartState from '../atoms/cart';

export const cartProducts = selector({
  key: 'cartProducts',
  get: ({ get }) => {
    const cart = get(cartState);
    return cart.products;
  },
  set: ({ set, get }, newValue) => set(cartState, { ...get(cartState), products: newValue })
});

export const cartIdState = selector({
  key: 'cartIdState',
  get: ({ get }) => {
    const cart = get(cartState);
    return cart.cartId;
  },
  set: ({ set, get }, newValue) => {
    set(cartState, { ...get(cartState), cartId: newValue });
  }
});

export const cartStatus = selector({
  key: 'cartStatus',
  get: ({ get }) => {
    const cart = get(cartState);
    return cart.loaded;
  },
  set: ({ set, get }, newValue) => {
    set(cartState, { ...get(cartState), loaded: newValue });
  }
});

export const cartPrice = selector({
  key: 'cartPrice',
  get: ({ get }) => {
    const cart = get(cartState);
    let cartTotal = 0;
    Object.values(cart.products).forEach((product) => {
      if (Number(product.amount)) { cartTotal += Number(product.amount) * Number(product.quantity); }
    });
    return {
      total: cart.discount ? cart.total : cartTotal,
      cartTotal,
      shipping: cart.shipping,
      currency_code: cart?.products[0]?.currency_code || cart.currency_code,
      discount: cart.discount,
      coupons: cart.coupons,
      subTotal: cart.subTotal
    };
  },
  set: ({ set, get }, discountDetails) => {
    set(cartState,
      {
        ...get(cartState),
        total: discountDetails?.totalAmount > 0 ? discountDetails.totalAmount : 0,
        discount: discountDetails?.discountAmount,
        subTotal: discountDetails?.subTotal,
        coupons: discountDetails?.coupons
      });
  }
});

export const cartTotal = selector({
  key: 'cartTotal',
  get: ({ get }) => {
    const cart = get(cartState);
    return cart.cartTotal;
  },
  set: ({ set, get }) => {
    const cart = get(cartState);
    let subtotal = 0;
    Object.values(cart.products).forEach((product) => {
      subtotal += Number(product.amount) * Number(product.quantity);
    });
    set(cartState,
      {
        ...get(cartState),
        cartTotal: subtotal
      });
  }
});

export const billingAddress = selector({
  key: 'billingAddress',
  get: ({ get }) => {
    const cart = { ...get(cartState) };
    return cart.shipping.billingAddress;
  },
  set: ({ get, set }, value) => {
    const newCart = get(cartState);
    newCart.shipping.billingAddress = {
      street1: value.address,
      zip: value.postCode
    };
    set(cartState, newCart);
  }
});

export const failedProducts = selector({
  key: 'failedProducts',
  get: ({ get }) => {
    const cart = get(cartState);
    return cart.failed_products;
  },
  set: ({ get, set }, failedProduct) => set(cartState, { ...get(cartState), failed_products: failedProduct })
});

export default cartProducts;
